import React, { createContext, useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";

const STORAGE_KEY = "CB_SHELL_SIDEBAR_COLLAPSED";
const MOBILE_MQ = "(max-width: 980px)";

const ShellContext = createContext({
  collapsed: false,
  setCollapsed: () => {},
  toggleCollapsed: () => {},
  mobileNavOpen: false,
  setMobileNavOpen: () => {},
  toggleMobileNav: () => {},
  closeMobileNav: () => {},
  isMobile: false,
});

export function ShellProvider({ children }) {
  const [collapsed, setCollapsedState] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === "1";
    } catch (e) {
      return false;
    }
  });
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return window.matchMedia(MOBILE_MQ).matches;
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, collapsed ? "1" : "0");
    } catch (e) {
      // ignore quota / private mode
    }
  }, [collapsed]);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return undefined;
    const mq = window.matchMedia(MOBILE_MQ);
    const onChange = () => {
      const mobile = mq.matches;
      setIsMobile(mobile);
      if (!mobile) setMobileNavOpen(false);
    };
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  const setCollapsed = (next) => setCollapsedState(Boolean(next));
  const toggleCollapsed = () => setCollapsedState((v) => !v);
  const toggleMobileNav = () => setMobileNavOpen((v) => !v);
  const closeMobileNav = () => setMobileNavOpen(false);

  return (
    <ShellContext.Provider
      value={{
        collapsed,
        setCollapsed,
        toggleCollapsed,
        mobileNavOpen,
        setMobileNavOpen,
        toggleMobileNav,
        closeMobileNav,
        isMobile,
      }}
    >
      {children}
    </ShellContext.Provider>
  );
}

ShellProvider.propTypes = {
  children: PropTypes.node,
};

export function useShell() {
  return useContext(ShellContext);
}

export default ShellContext;
